export const SHEET_W = 8.5;
export const SHEET_H = 11.0;
export const SHEET_MARGIN = 0.5;
export const SHEET_GAP = 0.25;

// Die-cut offset path added around the printed graphic contour (per side).
export const STICKER_OFFSET_IN = 0.25;

// Cut outline: 6% of the longest side, capped at the offset (1/4").
export function cutOutlineIn(w, h, offset = STICKER_OFFSET_IN) {
  return Math.min(0.06 * Math.max(Number(w), Number(h)), Number(offset));
}

// Border thickness as a fraction of the longest side — used to regenerate the
// baked die-cut preview so the outline stays a true inch at any print size.
export function cutOutlineRatio(w, h, offset = STICKER_OFFSET_IN) {
  const mx = Math.max(Number(w), Number(h)) || 1;
  return cutOutlineIn(w, h, offset) / mx;
}

// Visible sticker footprint = design + cut outline on each side. Sheet-cut nests
// by this (the true cut boundary), so stickers pack tightly with just the gap.
export function visibleDims(w, h, offset = STICKER_OFFSET_IN) {
  const r = cutOutlineIn(w, h, offset);
  return [Number(w) + 2 * r, Number(h) + 2 * r];
}

// Actual sticker footprint = printed image + offset path on each side.
export function actualDims(w, h, offset = STICKER_OFFSET_IN) {
  const o = Number(offset ?? STICKER_OFFSET_IN);
  return [Number(w) + 2 * o, Number(h) + 2 * o];
}

// Mirror of backend stickers_per_sheet: nest on an 8.5x11 liner, best orientation.
// Returns { n, cols, rows, rot } — rot=true means stickers are rotated 90deg.
export function nestSheet(w, h, gap = SHEET_GAP) {
  const usableW = SHEET_W - 2 * SHEET_MARGIN;
  const usableH = SHEET_H - 2 * SHEET_MARGIN;
  const count = (a, b) => {
    if (a <= 0 || b <= 0 || a > usableW || b > usableH) return { n: 0, cols: 0, rows: 0 };
    const cols = Math.max(Math.floor((usableW + gap) / (a + gap)), 0);
    const rows = Math.max(Math.floor((usableH + gap) / (b + gap)), 0);
    return { n: cols * rows, cols, rows };
  };
  const a = count(w, h);
  const b = count(h, w);
  return b.n > a.n ? { ...b, rot: true } : { ...a, rot: false };
}
